import React from 'react';
import Header from './Header';
import Footer from './Footer';
import FloatingButtons from './FloatingButtons';
import PageMeta from './PageMeta';

const PageLayout = ({ children, metaPath = '/' }) => (
  <div className="app">
    <PageMeta path={metaPath} />
    <Header />
    <main>{children}</main>
    <Footer />
    <FloatingButtons />
  </div>
);

export default PageLayout;
